import { render } from "./ContactView.vue?vue&type=template&id=4b62841a&scoped=true&ts=true"
import script from "./ContactView.vue?vue&type=script&lang=ts"
export * from "./ContactView.vue?vue&type=script&lang=ts"

import "./ContactView.vue?vue&type=style&index=0&id=4b62841a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b62841a"]])

export default __exports__